import React from 'react'
import styled from 'styled-components'
import Callout from '../components/callout'
import { MobileDeviceWidth, SmallMobileDeviceWidth } from '../lib/constants'

const StyledContainer = styled.div`
  position: absolute;
  left: 50%;
  z-index: 1;
  transform: translate(-50%, 0);
  margin-top: 15px;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.25);
  @media (max-width: ${SmallMobileDeviceWidth}px) {
    transform: unset;
    left: 60px;
    max-width: 50vw;
  }
  @media (max-width: ${MobileDeviceWidth}px) {
    font-size: 12px;
    margin-top: 10px;
  }
`

interface IProps {
  text: string
  type: string
}

class MapWarningControl extends React.Component<IProps, {}> {
  render() {
    return (
      <StyledContainer>
        <Callout type={this.props.type}>{this.props.text}</Callout>
      </StyledContainer>
    )
  }
}

export default MapWarningControl
